import CryptoJS from 'crypto-js';

// Використовуємо складний ключ (краще зберігати в .env файлі)
const SECRET_KEY = process.env.VUE_APP_ENCRYPTION_KEY || 'HFP-Default-Secret-Key-2024-Change-Me';

export function encrypt(text) {
	if (!text) return '';
	return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
}

export function decrypt(ciphertext) {
	if (!ciphertext) return '';
	const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
	return bytes.toString(CryptoJS.enc.Utf8);
}
